import React from "react";

const CloseSmallIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.23356 4.52645C5.0383 4.33118 4.72171 4.33118 4.52645 4.52645C4.33119 4.72171 4.33119 5.03829 4.52645 5.23355L6.29422 7.00132L4.52645 8.76909C4.33119 8.96435 4.33119 9.28093 4.52645 9.47619C4.72171 9.67146 5.0383 9.67146 5.23356 9.47619L7.00133 7.70843L8.76909 9.47619C8.96435 9.67146 9.28094 9.67146 9.4762 9.47619C9.67146 9.28093 9.67146 8.96435 9.4762 8.76909L7.70843 7.00132L9.4762 5.23355C9.67146 5.03829 9.67146 4.72171 9.4762 4.52645C9.28094 4.33118 8.96435 4.33118 8.76909 4.52645L7.00133 6.29421L5.23356 4.52645Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CloseSmallIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;